import React from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';
import UserAvatar from "app/shared-components/user/UserAvatar";
import UserName from "app/shared-components/user/UserName";
import ReferralDetailsInfo from "app/shared-components/referral/ReferralDetailsInfo";
import {useSelector} from "react-redux";
import {selectUser} from "app/store/userSlice";


const ReferralDetailsPane = ({
                            channelType,
                            referral,
                            enableActions,
                                 suppressDisplayClosed,
                            interest,
                            openDMDialog,
                                 openInterestDialog
                        }) => {

    const user= useSelector(selectUser);
    const isProvider = Boolean(referral?.provider);
    const isOwner = isProvider && user.id === referral.provider.id;
    const isClosed = referral?.status && referral.status.startsWith('closed');

    return (
    <div className="flex flex-col mt-32 px-32">
        {!isOwner &&
        <Card className="w-full mb-32">
            <div className="relative px-32 pt-24">
                <Typography className="text-2xl font-semibold leading-tight">
                    {isProvider ? 'Referred By Provider' : 'Requested By User'}
                </Typography>
            </div>

            <CardContent className="px-32 py-24">
                <div className="flex flex-row">
                    <div className="flex flex-grow">
                        <UserAvatar
                            className="relative mx-8"
                            user={isProvider ? referral.provider : referral.requestor}
                        />
                        <UserName
                            color="inherit"
                            user={isProvider ? referral.provider : referral.requestor}
                        />
                    </div>

                    {enableActions && !isClosed && (
                        <>
                            {interest ? (
                                <Button
                                    className="mx-8 whitespace-nowrap"
                                    variant="contained"
                                    color="secondary"
                                    onClick={openDMDialog}
                                >
                                    <span className="mx-8">View Chat</span>
                                </Button>
                            ) : (
                                <Button
                                    className="mx-8 whitespace-nowrap"
                                    variant="contained"
                                    color="secondary"
                                    onClick={openInterestDialog}
                                >
                                    <span className="mx-8">Express Interest</span>
                                </Button>
                            )}
                        </>
                    )}

                    {isClosed && !suppressDisplayClosed && (
                        <Button
                            className="mx-8 whitespace-nowrap"
                            variant="contained"
                            color="secondary"
                            disabled
                        >
                            <span className="mx-8">Referral Closed</span>
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
        }

        <Card className="w-full mb-32">
            <div className="relative px-32 pt-24">
                <Typography color="secondary" className="text-2xl font-semibold leading-tight">
                    {referral.summary}
                </Typography>
            </div>

            <CardContent className="px-32 py-24">
                <ReferralDetailsInfo showSummary={false} referral={referral} />
            </CardContent>

        </Card>
    </div>
    );
};

export default ReferralDetailsPane;

